var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "campaigns" }, [
    _c(
      "table",
      { staticClass: "w-full" },
      [
        _vm._m(0),
        _vm._v(" "),
        _vm._l(_vm.campaigns, function(campaign) {
          return _c(
            "tbody",
            { key: campaign.id },
            [
              _vm.campaignTotal(campaign.title) > 0
                ? [
                    _c(
                      "tr",
                      { staticClass: "bg-lime text-white text-xl font-bold" },
                      [
                        _c("td", {
                          staticClass: "p-2",
                          attrs: { colspan: "3" },
                          domProps: { innerHTML: _vm._s(campaign.title) }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.displayProducts(campaign.title), function(item) {
                      return _c(
                        "tr",
                        { key: item.id, staticClass: "bg-light-grey" },
                        [
                          _c("td", {
                            staticClass: "border divide-primary p-2",
                            domProps: { innerHTML: _vm._s(item.title) }
                          }),
                          _vm._v(" "),
                          _c("td", {
                            staticClass:
                              "border divide-primary p-2 align-top text-center",
                            domProps: { innerHTML: _vm._s(item.qty) }
                          }),
                          _vm._v(" "),
                          _c("td", {
                            staticClass:
                              "border divide-primary p-2 align-top text-center",
                            domProps: {
                              innerHTML: _vm._s(_vm.equivalized(item))
                            }
                          })
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _c("tr", { staticClass: "font-bold" }, [
                      _c(
                        "td",
                        { staticClass: "border divide-primary text-right" },
                        [_vm._v("Campaign Total:")]
                      ),
                      _vm._v(" "),
                      _c("td", {
                        staticClass: "border divide-primary text-center",
                        domProps: {
                          innerHTML: _vm._s(_vm.campaignTotal(campaign.title))
                        }
                      }),
                      _vm._v(" "),
                      _c("td", {
                        staticClass: "border divide-primary text-center",
                        domProps: {
                          innerHTML: _vm._s(_vm.campaignEqTotal(campaign.title))
                        }
                      })
                    ])
                  ]
                : _vm._e()
            ],
            2
          )
        }),
        _vm._v(" "),
        _c("tfoot", [
          _c("tr", { staticClass: "text-xl text-green font-bold bg-primary" }, [
            _c("td", { staticClass: "p-2 uppercase" }, [
              _vm._v("Seasonal Total")
            ]),
            _vm._v(" "),
            _c("td", {
              staticClass: "p-2 align-top text-center",
              domProps: { innerHTML: _vm._s(_vm.seasonalTotal) }
            }),
            _vm._v(" "),
            _c("td", {
              staticClass: "p-2 align-top text-center",
              domProps: { innerHTML: _vm._s(_vm.totalEquivalized) }
            })
          ])
        ])
      ],
      2
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", { staticClass: "text-xl text-green font-bold bg-primary" }, [
        _c("td", { staticClass: "p-2" }, [_vm._v("Product Name")]),
        _vm._v(" "),
        _c("td", { staticClass: "p-2 text-center" }, [_vm._v("Qty.")]),
        _vm._v(" "),
        _c("td", { staticClass: "p-2 text-center" }, [
          _vm._v("Equivalized Qty.")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }